import { BASE_URL, SYSTEM_ERROR, POST_DOWNLOAD_CUSTOMER_DEMANDS_REPORT } from "./CONSTANTS";
import { Post } from "./apiService";

export const generateDownloadReport = (request) => {
    return new Promise((resolve, reject) => {
        try {
            request.url = `${BASE_URL}users/userId/${POST_DOWNLOAD_CUSTOMER_DEMANDS_REPORT}?apikey=${request.apiKey}`;
            request.config = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                }
            }
            Post(request)
                .then((res) => {
                    if (res && res.status === 200) {
                        resolve(res.data);
                    } else {
                        reject(res.data);
                    }
                })
                .catch((errResponse) => {
                    reject(errResponse);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};